import { VFC, ReactNode } from 'react';
import classNames from 'classnames';
import { useTextOverflow } from '../common/useTextOverflow';
import './index.scss';

interface Iprops {
  location: string;
  extra?: ReactNode | string;
  line?: number;
  className?: string;
  posterId: number;
}
const PosterLocation: VFC<Iprops> = ({ location, className, extra, line, posterId }) => {
  const { containerRef, textsRef, textDoms } = useTextOverflow(location, posterId);
  return (
    <div className={classNames('poster-location', className)}>
      {extra && <div className="poster-location-extra">{extra}</div>}
      <div
        className={classNames('poster-location-string', line ? `line-${line}` : '')}
        ref={containerRef}
      >
        <span className="poster-location-string-value" ref={textsRef}>
          {textDoms}
        </span>
      </div>
    </div>
  );
};

export default PosterLocation;
